import {HttpError} from '@wix/http-client';

export const toMonitorError = (
  error: unknown,
  description?: string
): [
  exception: Error,
  options?: {
    context?: Record<string, any>;
    tags?: Record<string, string | number | boolean | null | undefined>;
  }
] => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const errorMessage = `Error: ${JSON.stringify((error as HttpError)?.response?.data.message)}`;
  return [
    new Error(description ? `${description} ${errorMessage}` : errorMessage),
    {
      tags: {tagName: errorMessage},
      context: {
        fullError: JSON.stringify(error as Error),
      },
    },
  ];
};
